<script>

export default {
  computed: {
    campaignCartItems() {
      return this.$store.state.cart.cart;
    },
  },
  methods: {
    navigate(path) {
      if (path !== this.$router.currentRoute.path) {
        this.$router.push(path);
      }
    },
  }
}
</script>

<template>
  <div>
    <div v-if="Object.keys(campaignCartItems).length === 0" class="notification-item">
      <div class="media">
        {{ $t('Your Influencertes Cart is empty') }}
      </div>
    </div>
    <div v-for="campaignCartItem in campaignCartItems" :key="campaignCartItem.campaignId" class="border-top">
      <router-link :to="`/client/cart/${campaignCartItem.campaignId}`" tag="a" class="has-pointer-cursor text-reset notification-item">
        <div class="media">
          <div class="mr-3">
            <!--                    <img v-if="notification.data.subject_picture_url" :src="`${notification.data.subject_picture_url}`" @error="notification.data.subject_picture_url=false" class="rounded-circle avatar-sm border-1 ml-minus-5" :alt="notification.data.subject_name" />-->
            <!--                    <div v-else-if="notification.data.subject_name"  class="avatar-sm letter-in-circle-2 border-1 ml-minus-5" style="background: gray">{{ notification.data.subject_name.charAt(0) }}</div>-->
          </div>
          <div class="media-body">
            <p class="mt-0 mb-1">{{ campaignCartItem.campaignInternalName }}</p>
          </div>
        </div>
      </router-link>
<!--      <a class="has-pointer-cursor text-reset notification-item" @click="navigate(`/client/cart/${campaignCartItem.campaignId}`)">-->
<!--        <div class="media">-->
<!--          <div class="mr-3">-->
<!--            &lt;!&ndash;                    <img v-if="notification.data.subject_picture_url" :src="`${notification.data.subject_picture_url}`" @error="notification.data.subject_picture_url=false" class="rounded-circle avatar-sm border-1 ml-minus-5" :alt="notification.data.subject_name" />&ndash;&gt;-->
<!--            &lt;!&ndash;                    <div v-else-if="notification.data.subject_name"  class="avatar-sm letter-in-circle-2 border-1 ml-minus-5" style="background: gray">{{ notification.data.subject_name.charAt(0) }}</div>&ndash;&gt;-->
<!--          </div>-->
<!--          <div class="media-body">-->
<!--            <p class="mt-0 mb-1">{{ campaignCartItem.campaignInternalName }}</p>-->
<!--          </div>-->
<!--        </div>-->
<!--      </a>-->
    </div>
  </div>
</template>
<style lang="scss" scoped>
.router-link-exact-active.router-link-active {
  color: inherit !important;
  .media {
    background-color: #f6f6f6 !important;
  }
}
</style>
